import React, { Component } from "react";
import { Col, Container, Card, Row } from "reactstrap";
import { Link } from "react-router-dom";

import { Link as ScrollLink } from 'react-scroll';

import Laptop from '../assets/images/bg/laptop.png';
import { MDBAlert, MDBBtn, MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import {
    NavbarBrand,

} from "reactstrap";
import logodark from "../assets/images/Easy-MembrLogo.png";
import logolight from "../assets/images/Easy-MembrLogo.png";
import Logo from "../assets/images/Easy-MembrLogo.png";
import Privacy from "../../components/privacy";
import Terms from "../../components/terms.js";
import Faqs from "../../components/faqs.js";
import Popup from "../../components/Popup";
import * as Icon from 'react-feather';
import { customPremium } from "../../services/apiServices";

class NewLeads extends Component {

    constructor(props) {
        super(props);
        this.state = {
            nanoTerm: '12',
            standardTerm: '1',
            premiumTerm: '1',
            services: [
                {
                    id: 'service6',
                    icon: 'expand-arrows-alt',
                    title: "Informative Dashboard with Insights",
                    description: `Make data-driven decisions with EasyMembr\'s real-time dashboard that provides actionable insights into member behavior, attendance, and financial performance. Monitor your gym's health at a glance through EasyMembr and make informed choices to boost retention and revenue.`
                },
                {
                    id: 'service5',
                    icon: 'flip-h',
                    title: "Intuitive Point of Sale (PoS)",
                    description: `Simplify payment processing with EasyMembr\'s easy-to-use PoS system. Record payments, associate them with memberships, and handle class or service fees efficiently—all within the EasyMembr platform.`
                },
                {
                    id: 'service4',
                    icon: 'fire',
                    title: "Slot-Based Membership Plans",
                    description: `Offer flexible membership options through EasyMembr with different pricing for various time slots. Whether it's off- peak discounts or premium peak - time packages, EasyMembr helps you customize offerings to meet demand.`
                },
                {
                    id: 'service1',
                    icon: 'users-alt',
                    title: "Member Management",
                    description: `Stay organized with EasyMembr's comprehensive member management system. Easily track profiles, membership plans, and attendance records all in one platform designed for gym owners.`
                },
                {
                    id: 'service2',
                    icon: 'signin',
                    title: "Quick QR check-In",
                    description: `Streamline gym access with EasyMembr\'s frictionless check-in system. Members can check in quickly upon arrival, while you maintain secure control through the EasyMembr platform.`
                },
                {
                    id: 'service3',
                    icon: 'mountains',
                    title: "Membership Add-ons",
                    description: `Boost revenue using EasyMembr to offer value-added services like personal training and nutritional counseling. Easily attach these add-ons to members\' plans within the EasyMembr system.`
                },
                {
                    id: 'service7',
                    icon: 'calendar-alt',
                    title: "Class Booking System",
                    description: 'EasyMembr\'s intuitive class booking system empowers both admins and members. Create sessions with dates/times, set capacities, and let members book via EasyMembr\'s simple interface that shows real-time availability.'
                },
                {
                    id: 'service8',
                    icon: 'clock',
                    title: "Reminders & Notifications",
                    description: 'Keep members informed and engaged with automated reminders and real-time notifications. From class bookings to payment alerts, EasyMembr ensures your members never miss an update.'
                }
            ],
            showComparisonModal: false,
            comparisonData: {
                features: [
                    { name: 'Login With Google Account', nano: true, standard: true, premium: true },
                    { name: 'Dashboard', nano: true, standard: true, premium: true },
                    { name: 'Member Check-In', nano: true, standard: true, premium: true },
                    { name: 'Membership Plans', nano: true, standard: true, premium: true },
                    { name: 'Receipt', nano: true, standard: true, premium: true },
                    { name: 'Reports', nano: true, standard: true, premium: true },
                    { name: 'Digital Waiver', nano: true, standard: true, premium: true },
                    { name: 'QR check-in', nano: true, standard: true, premium: true },
                    { name: 'WhatsApp integration', nano: true, standard: true, premium: true },
                    { name: 'SMS integration', nano: true, standard: true, premium: true },
                    { name: 'Accountant Role', nano: false, standard: true, premium: true },
                    { name: 'Member Identification', nano: false, standard: true, premium: true },
                    { name: 'Plans With Sessions Limit', nano: false, standard: true, premium: true },
                    { name: 'Addons', nano: false, standard: true, premium: true },
                    { name: 'Edit Membership', nano: false, standard: true, premium: true },
                    { name: 'Sessions sharing', nano: false, standard: false, premium: true },
                    { name: 'SubDomain', nano: false, standard: false, premium: true },
                ]
            },

            from: props.from,
            plansData: null,
            firstName: "",
            email: "",
            phone: "",
            inquiry: "",
            toggleMenu: false,
            logourl: localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl || logodark) : logodark,
            imageLoaded: true,
            arrow: false,
            popup: false,
            popup1: false,
            popup2: false,
            alerttxt: "",
            status: "",
            errors: {
                firstName: "",
                email: "",
                phone: "",
                inquiry: "",
            },
            // logourl: localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl || Logo) : Logo,
            // imageLoaded: true
        };
        window.addEventListener("scroll", this.windowScroll);
        console.log(props);
    }

    toggleComparisonModal = () => {
        this.setState(prevState => ({
            showComparisonModal: !prevState.showComparisonModal
        }));
    };

    /**
     * Window scroll 
     */

    fetchData = async () => {
        // const response = await getAllPricingPlans();
        // if (!response || response === "false") {
        //     return;
        // }
        // const recinfo = await response.json();
        // this.setState({ plansData: recinfo });
    };

    windowScroll() {
        const navbar = document.getElementById("navbar");
        if (navbar) {
            if (
                document.body.scrollTop >= 50 ||
                document.documentElement.scrollTop >= 50
            ) {
                navbar.classList.add("nav-sticky");
            } else {
                navbar.classList.remove("nav-sticky");
            }
        }
    }

    componentDidMount() {
      
        this.fetchData()
    }


    handleSubmit = async (e) => {
        e.preventDefault();
        const { firstName, email, phone, inquiry, errors } = this.state;

        // Validate all fields before submission
        if (!this.validateForm()) return;

        const updates = {
            fname: firstName,
            email: email,
            number: phone,
            inquiry: inquiry,
            from: "leads",
        };

        try {
            const response = await customPremium(updates);
            if (response.status === 200) {
                // Reset the form
                this.setState({
                    firstName: "",
                    email: "",
                    phone: "",
                    inquiry: "",
                    errors: {
                        firstName: "",
                        email: "",
                        phone: "",
                        inquiry: "",
                    },

                });
                this.setState({ alerttxt: "Your inquiry has been submitted successfully!", status: "success" })

            } else {
                this.setState({ alerttxt: "There was an issue submitting your inquiry. Please try again.", status: "danger" })

            }
        } catch (error) {
            console.error("Error submitting form: ", error);
            // alert("An error occurred. Please try again later.");
            this.setState({ alerttxt: "An error occurred. Please try again later.", status: "danger" })
        }
    };

    handleChange = (e) => {
        const { id, value } = e.target;
        this.setState({ [id]: value }, () => this.validateField(id, value));
    };

    validateField = (fieldName, value) => {
        let errors = { ...this.state.errors };

        switch (fieldName) {
            case "firstName":
                errors.firstName = value.trim() === "" ? "First name is required." : "";
                break;
            case "email":
                errors.email = /\S+@\S+\.\S+/.test(value) ? "" : "Enter a valid email address.";
                break;
            case "phone":
                errors.phone =
                    value.trim() === "" || value.length < 10
                        ? "Enter a valid 10-digit phone number."
                        : "";
                break;
            case "inquiry":
                errors.inquiry = value.trim() === "" ? "Inquiry message is required." : "";
                break;
            default:
                break;
        }

        this.setState({ errors });
    };

    validateForm = () => {
        const { firstName, email, phone, inquiry } = this.state;

        // Trigger validation for all fields
        this.validateField("firstName", firstName);
        this.validateField("email", email);
        this.validateField("phone", phone);
        this.validateField("inquiry", inquiry);

        const { errors } = this.state;

        // Check if there are any errors
        return !Object.values(errors).some((error) => error !== "");
    };

    handleImageLoad = () => {
        this.setState({ imageLoaded: true });
    };

    handleImageError = () => {
        this.setState({ imageLoaded: false });
    };

    // componentDidMount() {
    //     window.addEventListener('scroll', this.handleScroll);
    // }

    // componentWillUnmount() {
    //     window.removeEventListener('scroll', this.handleScroll);
    // }

    // handleScroll() {
    //     if (document.body.scrollTop >= 500 || document.documentElement.scrollTop >= 500) {
    //         this.setState({ arrow: true });
    //     } else {
    //         this.setState({ arrow: false });
    //     }
    // }

    compopup = () => {
        this.setState({ popup: true })
    }

    handler = () => {
        this.setState({ popup: false })
    }

    compopup1 = () => {
        this.setState({ popup1: true })
    }

    handler1 = () => {
        this.setState({ popup1: false })
    }

    compopup2 = () => {
        this.setState({ popup2: true })
    }

    handler2 = () => {
        this.setState({ popup2: false })
    }

    handleImageLoad = () => {
        this.setState({ imageLoaded: true });
    };

    handleImageError = () => {
        this.setState({ imageLoaded: false });
    };


    handleralert = () => {
        this.setState({ alerttxt: "", status: "" })
    }
    render() {
        const { plansData, arrow, popup, popup1, popup2 } = this.state;
        const { logourl, imageLoaded } = this.state;
        const { firstName, email, phone, inquiry, errors, alerttxt } = this.state;
        const planid = plansData?.pricingPlans.find((obj) => obj.name === "Free Starter")?._id;

        return (

            <React.Fragment>
                <div>
                    <nav id="navbar" className="navbar navbar-expand-lg fixed-top sticky align-items-center justify-content-center">


                        <NavbarBrand to="/">
                            {imageLoaded ? (
                                <>
                                    <div className="d-flex align-items-center position-relative">
                                        <img src={logourl} alt="Logo" className="newLogo" onLoad={this.handleImageLoad} onError={this.handleImageError} />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="d-flex align-items-center position-relative">
                                        <img src={logodark} alt="Default Logo" className="newLogo" />
                                    </div>
                                </>

                            )}

                        </NavbarBrand>
                    </nav>
                    {/******Feature start*************/}
                    <React.Fragment>
                        {/*  Services START  */}
                        <section className="section mt-4 featur-seaction" id="">
                            <Container className="section mt-2 featur-seaction">
                                <Row className="justify-content-center">
                                    <div className="col-12">
                                        <div className="section-title text-center mb-4 pb-2">
                                            <h3 className="title mb-2">Maximize Your Gym’s Return on Investment (ROI) with Intent-Based Features from EasyMembr</h3>
                                            <p className="text-muted mx-auto para-desc mb-0">With EasyMembr, you can effortlessly enhance your gym’s operations and streamline standard operating procedures (SOPs). Here’s how:</p>
                                        </div>
                                    </div>
                                </Row>

                                <Row>
                                    {this.state.services.map((item, key) => (
                                        <Col lg={4} md={6} className="mt-5 pt-4" key={key}>
                                            <Card className="features feature-primary feature-shadow-md shadow rounded p-4 pt-5 prisingdiv">
                                                <div className="icon-style mt-n80 position-relative text-center shadow rounded bg-white mb-4">
                                                    <i className={"h4 mb-0 uil uil-" + item.icon}></i>
                                                </div>
                                                <div className="content">
                                                    <Link to="#" className="title text-dark h5">{item.title}</Link>
                                                    <p className="text-muted mt-3">{item.description}</p>
                                                </div>
                                            </Card>
                                        </Col>
                                    ))}

                                </Row>

                            </Container>


                        </section>

                    </React.Fragment>

                    {/******Feature end*************/}

                    {/******Pricing start*************/}
                    <React.Fragment>
                        <section className="section" id="pricing">
                            <Container>
                                <Row className="justify-content-center">
                                    <Col lg={12}>
                                        <div className="section-title text-center mb-4 pb-2">
                                            <h3 className="title mb-3">Easymembr Commercials</h3>

                                        </div>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item border-0 ps-0">
                                                <i className="uil uil-check-circle text-primary me-2"></i>
                                                All pricing plans include full access to EasyMembr’s Studio — a complete solution for Member and Class Management. Whether opting for a monthly plan or 1-year subscription, all users receive the same functionality, tools, and platform benefits.

                                            </li>
                                            <li className="list-group-item border-0 ps-0">
                                                <i className="uil uil-check-circle text-primary me-2"></i>
                                                Plans are designed to support scalability, operational efficiency, and seamless member engagement from day one.

                                            </li>
                                            <li className="list-group-item border-0 ps-0">
                                                <i className="uil uil-check-circle text-primary me-2"></i>
                                                Choose a duration that aligns with your business needs and activate full platform access instantly.
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>

                                <Row className="justify-content-center m-4">
                                    <Col lg={6} className="text-center">

                                        <MDBBtn size='sm' className="btn btn-primary btn-sm" onClick={this.toggleComparisonModal}>Compare All Plans</MDBBtn>
                                    </Col>
                                </Row>

                                <Row className="justify-content-center">
                                    <Col lg={12}>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover text-center">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col" className="align-middle">Feature</th>
                                                        <th scope="col">Nano</th>
                                                        <th scope="col">Standard</th>
                                                        <th scope="col">Premium</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <th scope="row" className="text-start">Active Members</th>
                                                        <td>30 Members</td>
                                                        <td>60 Members</td>
                                                        <td>Unlimited Members</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="text-start">Monthly Transactions</th>
                                                        <td>60 Transactions</td>
                                                        <td>200 Transactions</td>
                                                        <td>Unlimited Transactions</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="text-start">Staff/Admins</th>
                                                        <td>1 Admin</td>
                                                        <td>10 Staff/Admins</td>
                                                        <td>50 Staff/Admins</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="text-start">Class Booking</th>
                                                        <td>20 Classes/Month</td>
                                                        <td>80 Classes/Month</td>
                                                        <td>Unlimited</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="text-start">Membership Plans</th>
                                                        <td>5 Plans</td>
                                                        <td>20 Plans</td>
                                                        <td>Unlimited Plans</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="text-start">Addons</th>
                                                        <td>0 Addons</td>
                                                        <td>20 Addons</td>
                                                        <td>Unlimited Addons</td>
                                                    </tr>


                                                    <tr>
                                                        <th scope="row" className="text-start">Reports</th>
                                                        <td>Basic</td>
                                                        <td>Advanced</td>
                                                        <td>Premium</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row" className="text-start">Free Trial</th>
                                                        <td>N/A</td>
                                                        <td>30 days</td>
                                                        <td>30 days</td>
                                                    </tr>

                                                    {/* Pricing Row */}
                                                    <tr className="bg-light">
                                                        <th scope="row" className="text-start">Pricing</th>


                                                        <td style={{ minHeight: '130px' }}>
                                                            <div style={{ height: '55px' }}></div>
                                                            <h4 className="mb-0">Free</h4>
                                                            <div className="mt-2">
                                                                <Link to="/bookademo" className="btn btn-primary">Get Started</Link>
                                                            </div>
                                                        </td>

                                                        {/* Standard Plan */}

                                                        <td style={{ minHeight: '150px' }}>
                                                            <div className="d-flex w-100 mb-3">
                                                                <div className="tab-slider--nav">
                                                                    <ul className={`tab-slider--tabs d-flex align-items-center ${this.state.standardTerm === '12' ? "slide" : ""}`}>
                                                                        <li className={`tab-slider--trigger ${this.state.standardTerm === '1' ? 'active' : ''}`}
                                                                            onClick={() => this.setState({ standardTerm: '1' })}
                                                                            rel="tab1"
                                                                        >
                                                                            1 Month
                                                                        </li>
                                                                        <li
                                                                            className={`tab-slider--trigger ${this.state.standardTerm === '12' ? 'active' : ''}`}
                                                                            onClick={() => this.setState({ standardTerm: '12' })}
                                                                            rel="tab2"
                                                                        >
                                                                            12 Months
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>

                                                            <h4 className="mb-0">
                                                                ₹{this.state.standardTerm === '1' ? '1,834' : (
                                                                    <>
                                                                        1,667 <span className="text-decoration-line-through text-muted small ms-2">1,834</span>
                                                                    </>
                                                                )}
                                                                {this.state.standardTerm === '1' ? <></> : <small>/month</small>}
                                                                {this.state.standardTerm === '12' && (
                                                                    <small className="badge bg-success ms-2">10% Off</small>
                                                                )}
                                                            </h4>
                                                            <small className="text-muted fs-10px" >
                                                                {/* {this.state.standardTerm === '1' ? '₹1,834 billed monthly' : '₹20,004 billed annually'} */}
                                                                {this.state.standardTerm === '1' ? '' : '₹20,004 billed annually'}
                                                            </small>

                                                            <div className="mt-2">
                                                                <Link to="/bookademo" className="btn btn-primary">Get Started</Link>
                                                            </div>
                                                        </td>

                                                        {/* Premium Plan */}
                                                        <td style={{ minHeight: '150px' }}>
                                                            <div className="d-flex w-100 mb-3">
                                                                <div className="tab-slider--nav">
                                                                    <ul className={`tab-slider--tabs d-flex align-items-center ${this.state.premiumTerm === '12' ? "slide" : ""}`}>
                                                                        <li className={`tab-slider--trigger ${this.state.premiumTerm === '1' ? 'active' : ''}`}
                                                                            onClick={() => this.setState({ premiumTerm: '1' })}
                                                                            rel="tab1"
                                                                        >
                                                                            1 Month
                                                                        </li>
                                                                        <li
                                                                            className={`tab-slider--trigger ${this.state.premiumTerm === '12' ? 'active' : ''}`}
                                                                            onClick={() => this.setState({ premiumTerm: '12' })}
                                                                            rel="tab2"
                                                                        >
                                                                            12 Months
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>

                                                            <h4 className="mb-0">
                                                                ₹{this.state.premiumTerm === '1' ? '2,292' : (
                                                                    <>
                                                                        2,083 <span className="text-decoration-line-through text-muted small ms-2">2,292</span>
                                                                    </>
                                                                )}
                                                                {this.state.premiumTerm === '1' ? <></> : <small>/month</small>}
                                                                {this.state.premiumTerm === '12' && (
                                                                    <small className="badge bg-success ms-2">10% Off</small>
                                                                )}
                                                            </h4>
                                                            <small className="text-muted fs-10px" >
                                                                {/* {this.state.premiumTerm === '1' ? '₹2,292 billed monthly' : '₹24,996 billed annually'} */}
                                                                {this.state.premiumTerm === '1' ? '' : '₹24,996 billed annually'}
                                                            </small>

                                                            <div className="mt-2">
                                                                <Link to="/bookademo" className="btn btn-primary">Get Started</Link>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                    </React.Fragment>
                    {/******Pricing end*************/}

                    {/* Hero Start  */}
                    <section className="bg-half-170 d-table w-100 overflow-hidden bg-soft-primary" id="home">
                        <MDBContainer >
                            <MDBRow className="align-items-center">
                                <MDBCol sm={12} lg={6} md={6}>
                                    <div className="title-heading">
                                        <h1 className="heading my-3">Streamline Your GYM Operations with EasyMembr
                                        </h1>
                                        <p className="para-desc text-muted">Manage your gym's day-to-day operations with ease using EasyMembr, the all-in-one gym administration app designed for gym owners and managers.

                                        </p>

                                    </div>
                                </MDBCol>

                                <MDBCol sm={12} lg={6} md={6} className="mt-4 pt-2 mt-sm-0 pt-sm-0">
                                    <img src={Laptop} className="homepageImage" />
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </section>



                    {/******Contact start*************/}
                    <React.Fragment>
                        <section className="" id="contact">
                            <Container>
                                <Row className="justify-content-center">
                                    <Col>
                                        <div className="section-title text-center pb-2">
                                            <h4 className="title mb-3">Get In Touch!</h4>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="align-items-center">
                                    <Col lg={6} md={4} className="order-md-2 order-1 mt-4 pt-2">
                                        <div className="p-4 rounded shadow bg-white">
                                            <form
                                                id="contactForm"
                                                className="login-form"
                                                onSubmit={this.handleSubmit}
                                            >
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                First Name <span className="text-danger">*</span>
                                                            </label>
                                                            <div className="form-icon position-relative">
                                                                <input
                                                                    type="text"
                                                                    id="firstName"
                                                                    className="form-control"
                                                                    placeholder="First Name"
                                                                    value={firstName}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                                <p className="text-danger">{errors.firstName}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                Your Email <span className="text-danger">*</span>
                                                            </label>
                                                            <div className="form-icon position-relative">
                                                                <input
                                                                    type="email"
                                                                    id="email"
                                                                    className="form-control"
                                                                    placeholder="Email"
                                                                    value={email}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                                <p className="text-danger">{errors.email}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                Phone No. <span className="text-danger">*</span>
                                                            </label>
                                                            <div className="form-icon position-relative">
                                                                <input
                                                                    type="number"
                                                                    id="phone"
                                                                    className="form-control"
                                                                    placeholder="Phone No."
                                                                    value={phone}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                />
                                                                <p className="text-danger">{errors.phone}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label">
                                                                Inquiry <span className="text-danger">*</span>
                                                            </label>
                                                            <div className="form-icon position-relative">
                                                                <textarea
                                                                    id="inquiry"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Query..."
                                                                    value={inquiry}
                                                                    onChange={this.handleChange}
                                                                    required
                                                                ></textarea>
                                                                <p className="text-danger">{errors.inquiry}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="d-grid">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary"
                                                            >
                                                                Send
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={6} className="col-12 order-md-1 order-2 mt-4 pt-2">
                                        <div className="me-lg-4">
                                            <div className="d-flex">
                                                <div className="icons text-center">
                                                    <i className="uil uil-phone d-block rounded h4 mb-0"></i>
                                                </div>
                                                <div className="flex-1 ms-3">
                                                    <h5 className="mb-2">Phone</h5>
                                                    <p className="text-muted">+91 8019296262</p>
                                                </div>
                                            </div>
                                            <div className="d-flex mt-4">
                                                <div className="icons text-center">
                                                    <i className="uil uil-envelope d-block rounded h4 mb-0"></i>
                                                </div>
                                                <div className="flex-1 ms-3">
                                                    <h5 className="mb-2">Email</h5>
                                                    <p className="text-muted">support@easymembr.com</p>
                                                </div>
                                            </div>
                                            <div className="d-flex mt-4">
                                                <div className="icons text-center">
                                                    <i className="uil uil-map-marker d-block rounded h4 mb-0"></i>
                                                </div>
                                                <div className="flex-1 ms-3">
                                                    <h5 className="mb-2">Location</h5>
                                                    <p className="text-muted">
                                                        Sundaraiah Vignana Kendram, Survey No 91, Gachibowli Rd,
                                                        Madhava Reddy Colony, Gachibowli, Hyderabad, Telangana 500032
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                        <MDBAlert
                            color={this.state.status}
                            autohide
                            position='top-center'
                            delay={5000}
                            appendToBody
                            open={alerttxt != ""}
                            onClose={this.handleralert}
                        >
                            {alerttxt}
                        </MDBAlert>
                    </React.Fragment>
                    {/******Contact end*************/}

                    {/******Footer start*************/}
                    <React.Fragment>
                        {/* Back to top */}
                        {/* <Link2 to="home" style={{ display: arrow ? 'block' : 'none' }} id="back-to-top" className="back-to-top rounded-pill fs-5">
                            <Icon.ArrowUp className="fea icon-sm icons align-middle" />
                        </Link2> */}
                        {/* Back to top  */}

                        {/* Footer Start  */}
                        <footer className="bg-footer">

                            <div className="footer-py-30 footer-bar bg-footer">
                                <Container className="text-center">
                                    <Row className="align-items-center justify-content-between">
                                        <Col lg={3} md={2} sm={3}>
                                            <div className="">
                                                <Link to="#" className="logo-footer">
                                                    {imageLoaded ? (
                                                        <div className="d-flex align-items-center justify-content-end position-relative">
                                                            <img src={logourl} alt="Logo" onLoad={this.handleImageLoad} onError={this.handleImageError} className="newLogo me-3" />
                                                            {/* <div className="text-light fs-6 ByZencruzText" style={{ bottom: "-15px" }}>By Zencruz</div> */}
                                                        </div>
                                                    ) : (
                                                        <div className="d-flex align-items-center position-relative">
                                                            <img src={logodark} alt="Default Logo" className="newLogo" />
                                                            {/* <div className="text-primary fs-6 ByZencruzText">By Zencruz</div> */}
                                                        </div>
                                                    )}
                                                </Link>
                                            </div>
                                        </Col>

                                        <Col lg={6} md={6} sm={6} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                                            <ul className="list-unstyled footer-list terms-service mb-0">
                                                <li className="list-inline-item mb-0" >
                                                    <Link to="/privacypolicy" className="text-foot me-2">Privacy</Link>
                                                </li>
                                                <li className="list-inline-item mb-0">
                                                    <Link to="/terms" className="text-foot me-2">Terms</Link>
                                                </li>
                                                <li className="list-inline-item mb-0" onClick={this.compopup2}>
                                                    <Link to="#" className="text-foot me-2">FAQs</Link>
                                                </li>
                                                {/* <li className="list-inline-item mb-0">
                                            <Link to="/contact" className="text-foot">Contact</Link>
                                        </li> */}
                                            </ul>
                                        </Col>

                                        <Col lg={3} md={4} sm={3} className="mt-4 mt-sm-0 pt-2 pt-sm-0">
                                            <div className="text-sm-end">
                                                <p className="mb-0 text-foot">© {(new Date().getFullYear())}{" "} <Link to="#" className="text-reset">Zencruz.</Link></p>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </footer>

                        {/* Popups */}
                        {popup && (
                            <Popup
                                title="Privacy Policy for EasyMembr:"
                                ptype="modal-lg"
                                content={<Privacy />}
                                handleClose={this.handler}
                            />
                        )}
                        {popup1 && (
                            <Popup
                                title="Terms and Conditions for EasyMembr:"
                                ptype="modal-lg"
                                content={<Terms />}
                                handleClose={this.handler1}
                            />
                        )}
                        {popup2 && (
                            <Popup
                                title="FAQs for EasyMembr:"
                                ptype="modal-lg"
                                content={<Faqs />}
                                handleClose={this.handler2}
                            />
                        )}
                        {/* Footer End  */}
                    </React.Fragment>
                    {/******Footer end*************/}
                </div>
                {/* Comparison Modal */}
                <div className={`modal fade ${this.state.showComparisonModal ? 'show d-block' : ''}`} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-fullscreen">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Pricing Plans Comparison</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={this.toggleComparisonModal}
                                ></button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Feature</th>
                                            <th className="text-center">Nano</th>
                                            <th className="text-center">Standard</th>
                                            <th className="text-center">Premium</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.comparisonData.features.map((feature, index) => (
                                            <tr key={index}>
                                                <td>{feature.name}</td>
                                                <td className="text-center">
                                                    {feature.nano ? (
                                                        <i className="uil uil-check-circle text-success fs-5"></i>
                                                    ) : (
                                                        <i className="uil uil-times-circle text-danger fs-5"></i>
                                                    )}
                                                </td>
                                                <td className="text-center">
                                                    {feature.standard ? (
                                                        <i className="uil uil-check-circle text-success fs-5"></i>
                                                    ) : (
                                                        <i className="uil uil-times-circle text-danger fs-5"></i>
                                                    )}
                                                </td>
                                                <td className="text-center">
                                                    {feature.premium ? (
                                                        <i className="uil uil-check-circle text-success fs-5"></i>
                                                    ) : (
                                                        <i className="uil uil-times-circle text-danger fs-5"></i>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default NewLeads;
